import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

// Icônes en ligne plutôt qu'en assets : aucun pictogramme « sportives / équipes /
// profil » n'existe dans assets/footer, et la barre sportive n'en a pas non plus
// à réemployer. Elles reprennent la facture des SVG existants — trait de 1.67,
// bouts arrondis, viewBox 20 — et héritent du gris via `.footer__icon path`.
const iconProps = {
  className: 'footer__icon',
  width: 20, height: 20, viewBox: '0 0 20 20', fill: 'none',
  strokeWidth: 1.66667, strokeLinecap: 'round', strokeLinejoin: 'round',
};

const SportivesIcon = () => (
  <svg {...iconProps}>
    <path d="M13.3 17.5v-1.7a3.3 3.3 0 0 0-3.3-3.3H5a3.3 3.3 0 0 0-3.3 3.3v1.7" />
    <circle cx="7.5" cy="5.8" r="3.3" />
    <path d="M18.3 17.5v-1.7a3.3 3.3 0 0 0-2.5-3.2M13.3 2.7a3.3 3.3 0 0 1 0 6.4" />
  </svg>
);

const EquipesIcon = () => (
  <svg {...iconProps}>
    <path d="M2.5 16.7v-1.4a2.5 2.5 0 0 1 2.5-2.5h1.7a2.5 2.5 0 0 1 2.5 2.5v1.4" />
    <circle cx="5.8" cy="8.3" r="2.1" />
    <path d="M10.8 16.7v-1.4a2.5 2.5 0 0 1 2.5-2.5H15a2.5 2.5 0 0 1 2.5 2.5v1.4" />
    <circle cx="14.2" cy="8.3" r="2.1" />
    <path d="M10 2.5v3.3" />
  </svg>
);

const BlogIcon = () => (
  <svg {...iconProps}>
    <path d="M15.8 17.5H4.2a1.7 1.7 0 0 1-1.7-1.7V4.2a1.7 1.7 0 0 1 1.7-1.7h11.6a1.7 1.7 0 0 1 1.7 1.7v11.6a1.7 1.7 0 0 1-1.7 1.7Z" />
    <path d="M5.8 6.7h8.4M5.8 10h8.4M5.8 13.3h5" />
  </svg>
);

const ProfilIcon = () => (
  <svg {...iconProps}>
    <path d="M16.7 17.5v-1.7a3.3 3.3 0 0 0-3.4-3.3H6.7a3.3 3.3 0 0 0-3.4 3.3v1.7" />
    <circle cx="10" cy="5.8" r="3.3" />
  </svg>
);

const tabs = [
  { path: '/coach',         label: 'Sportives', Icon: SportivesIcon },
  { path: '/coach/equipes', label: 'Équipes',   Icon: EquipesIcon },
  { path: '/blog',          label: 'Blog',      Icon: BlogIcon },
  { path: '/profil',        label: 'Profil',    Icon: ProfilIcon },
];

const CoachFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="footer">
      {tabs.map((tab) => {
        // `/coach` couvre aussi les fiches sportives (/coach/sportive/:id), mais
        // pas /coach/equipes, qui a son propre onglet — d'où le préfixe exclu.
        const isActive = tab.path === '/coach'
          ? location.pathname.startsWith('/coach') && !location.pathname.startsWith('/coach/equipes')
          : location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            className={`footer__tab${isActive ? ' footer__tab--active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <tab.Icon />
            <span className="footer__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default CoachFooter;
